export const itemTypes = {
  STATIC: 'static',
  MODEL_3D: 'model_3d',
  VIDEO: 'video'
}